import { Link } from "react-router-dom";
import Navbar from "../../components/auth/Navabar";

const Solution = () => {
  const featureCards = [
    {
      title: "Research network",
      description:
        "Build connections with researchers, labs, and institutions around the world in a focused academic network.",
    },
    {
      title: "LMS learning hub",
      description:
        "Publish courses, modules, and learning content while learners track progress inside the same platform.",
    },
    {
      title: "Marketplace visibility",
      description:
        "Showcase research, prototypes, datasets, and services to institutions, industry partners, and students.",
    },
    {
      title: "Industry & university collaboration",
      description:
        "Connect research teams with university labs, industry sponsors, and innovation partners.",
    },
  ];

  return (
    <>
      {/* <Navbar /> */}
      <main className="bg-white text-slate-900">
        <section className="relative overflow-hidden bg-gradient-to-b from-[#e8f0f7] via-white to-white">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(15,106,191,0.14),_transparent_40%)]" />
          <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
            <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
              <div className="space-y-8">
                <span className="inline-flex items-center gap-2 rounded-full bg-[#0f6abf]/10 px-4 py-2 text-sm font-semibold text-[#0f6abf] ring-1 ring-[#0f6abf]/20">
                  <span className="h-2.5 w-2.5 rounded-full bg-[#0f6abf]" />
                  Our Solution
                </span>
                <h1 className="text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
                  A research ecosystem for universities, industry, and learners.
                </h1>
                <p className="max-w-2xl text-lg leading-8 text-slate-700">
                  Axionnest combines research publishing, LMS learning, marketplace discovery, and collaboration tools in one beautiful platform. Use this page to explain why the website exists and what problems it solves for research and education.
                </p>

                <div className="grid gap-4 sm:grid-cols-2">
                  <Link
                    to="/register"
                    className="inline-flex items-center justify-center rounded-full bg-[#0f6abf] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-[#0f6abf]/20 transition hover:bg-[#0d5ea5]"
                  >
                    Join the network
                  </Link>
                  <Link
                    to="/marketplace"
                    className="inline-flex items-center justify-center rounded-full border border-[#0f6abf] bg-white px-6 py-3 text-sm font-semibold text-[#0f6abf] transition hover:bg-[#0f6abf]/10"
                  >
                    Explore the marketplace
                  </Link>
                </div>
              </div>

              <div className="grid gap-4 sm:grid-cols-2">
                <div className="rounded-[2rem] border border-[#0f6abf]/10 bg-white p-6 shadow-lg shadow-slate-200/20">
                  <p className="text-sm uppercase tracking-[0.32em] text-[#0f6abf]">Research first</p>
                  <h2 className="mt-4 text-2xl font-semibold text-slate-900">Publish, share, and get discovered.</h2>
                  <p className="mt-3 text-sm leading-6 text-slate-600">
                    Bring your work to life with a platform that supports datasets, papers, videos, and collaborative projects.
                  </p>
                </div>
                <div className="rounded-[2rem] border border-[#0f6abf]/10 bg-white p-6 shadow-lg shadow-slate-200/20">
                  <p className="text-sm uppercase tracking-[0.32em] text-[#0f6abf]">Collaborate</p>
                  <h2 className="mt-4 text-2xl font-semibold text-slate-900">University + Industry</h2>
                  <p className="mt-3 text-sm leading-6 text-slate-600">
                    Connect faculty, labs, startups, and sponsors with a simple workflow for proposals, projects, and outcomes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <div className="grid gap-6 md:grid-cols-2 md:items-center">
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 rounded-full bg-[#e8f0f7] px-4 py-2 text-sm font-semibold text-[#0f6abf]">
                Research ecosystem
              </div>
              <h2 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
                One platform for networks, LMS, and marketplace discovery.
              </h2>
              <p className="max-w-2xl text-base leading-8 text-slate-600">
                Researchers, educators, and innovators can publish work, run learning programs, sell services, and build partnerships without leaving the same trusted environment.
              </p>
              <div className="grid gap-4 sm:grid-cols-2">
                <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
                  <p className="text-sm font-semibold text-slate-900">Learning Management</p>
                  <p className="mt-3 text-sm leading-6 text-slate-600">
                    Create courses, lessons, and guided learning tracks for students and collaborators.
                  </p>
                </div>
                <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
                  <p className="text-sm font-semibold text-slate-900">Marketplace reach</p>
                  <p className="mt-3 text-sm leading-6 text-slate-600">
                    Show your research outputs, prototypes, and services to an active academic and industry audience.
                  </p>
                </div>
              </div>
            </div>

            <div className="rounded-[2rem] overflow-hidden border border-slate-200 bg-white shadow-xl">
              <div className="relative aspect-video bg-slate-900">
                <video
                  className="h-full w-full object-cover"
                  controls
                  poster="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80"
                >
                  <source
                    src="https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-950/90 via-transparent p-5 text-white">
                  <p className="text-sm uppercase tracking-[0.3em] text-[#0f6abf]">Vision video</p>
                  <p className="mt-2 text-sm text-slate-200">
                    Use this space to explain how Axionnest helps research, teaching, and collaboration in one seamless workflow.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-2">
            <div className="space-y-6">
              <span className="inline-flex items-center gap-2 rounded-full bg-[#e8f0f7] px-4 py-2 text-sm font-semibold text-[#0f6abf]">
                Collaboration layer
              </span>
              <h2 className="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
                Work with industry, universities, and research teams.
              </h2>
              <p className="max-w-2xl text-base leading-8 text-slate-600">
                Axionnest is built for real-world impact. Create project proposals, match with technology sponsors, publish joint research, and keep partners aligned from idea to outcome.
              </p>
            </div>
            <div className="grid gap-4 sm:grid-cols-2">
              <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
                <h3 className="text-lg font-semibold text-slate-900">Industry partnerships</h3>
                <p className="mt-3 text-sm leading-6 text-slate-600">
                  Share applied research and collaborate with sponsors, tech teams, and lab partners.
                </p>
              </div>
              <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
                <h3 className="text-lg font-semibold text-slate-900">University networks</h3>
                <p className="mt-3 text-sm leading-6 text-slate-600">
                  Connect students, faculty, and researchers with project teams and curriculum-driven learning.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-4 pb-20 sm:px-6 lg:px-8">
          <div className="grid gap-6 lg:grid-cols-2">
            {featureCards.map((card) => (
              <div key={card.title} className="rounded-[2rem] border border-slate-200 bg-white p-8 shadow-sm transition hover:-translate-y-1 hover:shadow-md">
                <p className="text-sm font-semibold uppercase tracking-[0.28em] text-slate-500">{card.title}</p>
                <p className="mt-4 text-lg font-semibold text-slate-900">{card.title}</p>
                <p className="mt-3 text-sm leading-6 text-slate-600">{card.description}</p>
              </div>
            ))}
          </div>
        </section>
      </main>
    </>
  );
};

export default Solution;
